import React from "react";
import CallAPI from "../../../adminpanel/components/commonComponents/AxiosHelper";

const formUpload = {
    "shareUserForm": {
        "userName": {
            "name": "userName", "label": "Shared to Users", "type": "text", "tagsInputFlag": true, disabled: false
        },
        "addUser": {
            "name": "addUser", "label": "Add Users", "type": "dropdown", "options": [], multiple: true, requiredFlag: false
        }
    },
    "downloadReportForm": {
        "downloadType": {
            "name": "downloadType", "label": "Download Report as:", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "PDF", "value": "pdf" },
                // { "name": "CSV", "value": "csv" }
            ], "requiredFlag": true
        }
    }
}

const modalConfig = {
    "shareUserModal": {
        "id": "shareUserModal", "form_name": "shareUser", "form_id": "shareUserForm", "title": "Shared Users", "body": null, "button_name": "Share", buttonType: "submit", "display": true
    },
    "downloadReportModal": {
        "id": "downloadReportModal", "form_name": "downloadReport", "form_id": "downloadReportForm", "title": "Download Report", "body": null, "button_name": "Generate", buttonType: "submit", "display": true
    },
}

export function ReportModal(row, setmodalToView, clickName, authData) {
    if (clickName === "downloadReport" && authData.companyName === "Deloitte") {
        const link = document.createElement('a');
        link.href = `${window.location.origin}/assets/sampleFile/Downloadable report_LUCRUM.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        let formData = JSON.parse(JSON.stringify(formUpload[`${clickName}Form`]));
        let config = JSON.parse(JSON.stringify(modalConfig[`${clickName}Modal`]));
        let list_of_users_options, listOfUserArray = [];
        if (clickName === "shareUser") {
            if (JSON.parse(list_users).length > 0) {
                list_of_users_options = JSON.parse(list_users).map(function (innerData, index) {
                    listOfUserArray.push({ "name": innerData.label, "value": innerData.value })
                    return <option value={innerData.value}>{innerData.label}</option>;
                });
            }
            formData['userName']['text_value'] = JSON.parse(row.toUser);
            formData['addUser']['options'] = listOfUserArray
        } else if (clickName === "downloadReport") {
            formData['downloadType']['text_value'] = 'pdf'
            formData['downloadType']['disabled'] = true
        }
        config['title'] = <>{`${config['title']}`}<span><>({`${row.reportName}`})</></span></>;
        config['formKey'] = `${clickName}Form_${Math.floor(Math.random() * 10)}`;
        config['isLoading'] = false;
        setmodalToView({ modal: config, formData: formData, row: row, type: clickName });
        setTimeout(() => {
            clickName === "shareUser" ? jQuery("#userName_form_data").tagsinput() : null;
            jQuery(`#${clickName}Modal`).modal('toggle');
        }, 5);
    }
}

export function ModalSubmission(e, tableData, setReportData, authData, modalToView, setmodalToView) {
    let target = e.target.name;
    if (target === "shareUser") {
        let tempArr = []
        $(`#${target}Form`).serializeArray().map((innerData) => {
            if (innerData.value !== "") {
                if (innerData.name === 'userName') {
                    tempArr = innerData.value.split(',');
                } else {
                    tempArr.push(innerData.value);
                }
            }
        })
        let tempObject = [...tableData];
        let valueToCheck = 'reportName';
        tempObject.map(individualObj => {
            if (individualObj[valueToCheck] === modalToView.row[valueToCheck]) {
                individualObj["toUser"] = JSON.stringify(tempArr);
                if (individualObj['rockmetric_update_columns'] === null || individualObj['rockmetric_update_columns'] === undefined) {
                    individualObj['rockmetric_update_columns'] = [];
                }
                individualObj['rockmetric_update_columns'].push("toUser")
            }
        });
        setReportData({ data: tempObject, enableSave: 1 });
    } else if (target === "downloadReport") {
        let sampleModalData = { ...modalToView }
        let params = {
            siteId: authData.siteId,
            toolId: authData.toolId,
            user: authData.userId,
            id: modalToView.row["id"]
            //test: true //false
        }
        let url = '/app/generate_report';
        let postBody = { "api_request": true }
        sampleModalData.modal['isLoading'] = true
        sampleModalData.modal['formKey'] = `${sampleModalData.type}Form_${Math.floor(Math.random() * 10)}`;
        setmodalToView(sampleModalData);
        CallAPI('POST', url, postBody, params, 0, function (response) {
            if (response.status === true) {
                if (response.information.status === true) {
                    alert(response.information.information);
                    // window.open("/requestLogs/app")
                } else alert(response.information.error_message)
            } else alert(response.error_message);
        }, authData);
    }
    setTimeout(() => {
        jQuery(`#${target}Modal`).modal('toggle');
        jQuery('#userName_form_data').tagsinput('destroy');
    }, 5);
    e.preventDefault();
}